module.exports = "<form #subReportsSelect=\"ngForm\">\r\n    <div id=\"ChronosSubReportList\"></div>\r\n    <button type=\"button\" class=\"btn btn-lg btn-native\" (click)=\"saveChanges()\" id=\"saveChanges\">Save</button>\r\n</form>\r\n"


//////////////////
// WEBPACK FOOTER
// ./app/insa-components/insa-cron/insa-job/insa-activities-detail/report-job-details/subreport.component.html
// module id = 1775
// module chunks = 2